(() => {
  'use strict';
  const dialog = document.getElementById('sabo-shop');
  if (!dialog || !dialog.showModal) return;
  const content = dialog.querySelector('[data-shop-content]');
  const status = dialog.querySelector('[data-shop-status]');
  const title = dialog.querySelector('#sabo-shop-title');
  const root = window.Shopify?.routes?.root || '/';
  const allowed = new Set([...document.querySelectorAll('[data-sabo-product]')].map(a => a.dataset.saboProduct));
  let opener, serial = 0, busy = false, oldOverflow = '', currency = 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
  const el = (tag, text, cls) => { const n = document.createElement(tag); if (text) n.textContent = text; if (cls) n.className = cls; return n; };
  async function api(path, data) {
    const response = await fetch(root + path, {method:data ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{'Accept':'application/json', ...(data ? {'Content-Type':'application/json'} : {})}, ...(data ? {body:JSON.stringify(data)} : {})});
    let result;
    try { result = await response.json(); } catch { throw new Error('Could not reach the shop. Please try again.'); }
    if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
    return result;
  }
  function announce(text) { status.textContent = text; }
  function lock(value) { busy = value; dialog.querySelectorAll('button,input,select').forEach(n => { if (!n.hasAttribute('data-shop-close')) n.disabled = value || n.dataset.unavailable === 'true'; }); }
  function open(trigger, heading) {
    opener = trigger; title.textContent = heading; content.replaceChildren(); announce('Loading…');
    if (!dialog.open) { oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal(); }
    dialog.querySelector('[data-shop-close]').focus();
  }
  function badge(cart) {
    currency = cart.currency || currency;
    document.querySelectorAll('.sabo-bag').forEach(n => { n.textContent = `Bag (${cart.item_count})`; });
    const sticky = document.querySelector('[data-sabo-sticky-bag]');
    if (!sticky) return;
    const summary = cart.item_count ? `${cart.item_count} item${cart.item_count === 1 ? '' : 's'} · ${money(cart.total_price)}` : 'Your bag is empty';
    sticky.querySelector('[data-bag-summary]').textContent = summary;
    sticky.setAttribute('aria-label', `View bag: ${summary}`);
    const thumbs = sticky.querySelector('[data-bag-thumbs]'); thumbs.replaceChildren();
    cart.items.slice(0, 3).forEach(item => { if (!item.image) return; const img = el('img'); img.src = item.image; img.alt = ''; img.width = 40; img.height = 48; thumbs.append(img); });
    thumbs.hidden = !thumbs.children.length;
  }
  function action(text, fn, cls = 'sabo-shop-button') { const b = el('button',text,cls); b.type='button'; b.addEventListener('click',fn); return b; }
  dialog.querySelector('[data-shop-close]').addEventListener('click',() => dialog.close());
  dialog.addEventListener('click',e => { if(e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close(); } });
  dialog.addEventListener('close',() => { serial++; document.body.style.overflow=oldOverflow; opener?.focus(); });
  async function product(handle, trigger) {
    if (busy || !allowed.has(handle)) return;
    const ticket=++serial; open(trigger,'A closer look');
    try {
      const p=await api(`products/${encodeURIComponent(handle)}.js`);
      if(ticket!==serial || !dialog.open) return;
      title.textContent=p.title;
      const grid=el('div',null,'sabo-shop-product');
      const gallery=el('div',null,'sabo-shop-gallery');
      const main=el('img'); main.alt=p.title; main.src=p.images[0] || ''; gallery.append(main);
      const thumbs=el('div',null,'sabo-shop-thumbs');
      p.images.forEach((src,i) => { const b=action('',()=>{main.src=src;},'sabo-shop-thumb'); b.setAttribute('aria-label',`Photo ${i+1}`); const img=el('img');img.src=src;img.alt='';img.loading='lazy';b.append(img);thumbs.append(b); }); gallery.append(thumbs);
      const info=el('div',null,'sabo-shop-info');
      const price=el('p',null,'sabo-shop-price');
      const description=el('div',null,'sabo-shop-description');
      const doc=new DOMParser().parseFromString(p.description || '', 'text/html');
      doc.querySelectorAll('script,style,iframe').forEach(n=>n.remove());
      doc.querySelectorAll('p,li,br,h1,h2,h3,h4').forEach(n=>n.append('\n'));
      description.textContent=doc.body.textContent.trim();
      const variantLabel=el('label','Choose an option'); const select=el('select'); select.setAttribute('aria-label','Product option');
      p.variants.forEach(v=>{const o=el('option',v.title+(v.available?'':' — Sold out'));o.value=String(v.id);select.append(o);});
      select.value=String((p.variants.find(v=>v.available) || p.variants[0]).id); variantLabel.append(select);variantLabel.hidden=p.variants.length===1;
      const quantityLabel=el('label','Quantity');const qty=el('input');qty.type='number';qty.min='1';qty.max='99';qty.step='1';qty.value='1';qty.setAttribute('aria-label','Quantity');quantityLabel.append(qty);
      const add=action('Add to bag',async()=>{
        if(busy) return;
        const v=p.variants.find(v=>String(v.id)===select.value);const quantity=Number(qty.value);
        if(!v?.available || !Number.isInteger(quantity) || quantity<1 || quantity>99) {announce('Choose a quantity between 1 and 99.');return;}
        lock(true);announce('Adding to your bag…');
        let added=false;
        try {
          await api('cart/add.js',{items:[{id:v.id,quantity}]}); added=true;
          const cart=await api('cart.js'); badge(cart);
          if(ticket===serial && dialog.open) {announce(`Added to your bag. ${cart.item_count} item${cart.item_count===1?'':'s'} in your bag.`); view.hidden=false;}
        } catch(e) { if(ticket===serial && dialog.open) announce(added ? 'Added to your bag. Open the bag to check its contents.' : e.message); if(added) view.hidden=false; }
        finally {lock(false);}
      });
      const view=action('View bag',()=>bag(trigger),'sabo-shop-secondary');view.hidden=true;
      function choose(){const v=p.variants.find(v=>String(v.id)===select.value);price.textContent=money(v.price);add.dataset.unavailable=String(!v.available);add.disabled=!v.available;add.textContent=v.available?'Add to bag':'Sold out';}
      select.addEventListener('change',choose); choose();
      info.append(price,description,variantLabel,quantityLabel,add,view);
      grid.append(gallery,info);content.append(grid);announce('');
    } catch(e) { if(ticket===serial && dialog.open) announce(e.message); }
  }
  async function bag(trigger) {
    if(busy) return;
    const ticket=++serial;open(trigger,'Your bag');
    try {const cart=await api('cart.js');if(ticket!==serial || !dialog.open) return;badge(cart);drawCart(cart,ticket,trigger);announce('');}
    catch(e){if(ticket===serial)announce(e.message);}
  }
  function drawCart(cart,ticket,trigger) {
    content.replaceChildren();
    if(!cart.item_count) {content.append(el('p','Your bag is empty. There’s a little world waiting below.'));return;}
    const lines=el('div',null,'sabo-shop-lines');
    cart.items.forEach(item=>{
      const line=el('div',null,'sabo-shop-line');const img=el('img');img.src=item.image || '';img.alt=item.product_title;
      const details=el('div');details.append(el('h3',item.product_title));if(item.variant_title)details.append(el('p',item.variant_title));details.append(el('p',money(item.final_line_price)));
      const controls=el('div',null,'sabo-shop-quantity');
      async function change(quantity){
        if(busy)return;lock(true);announce('Updating bag…');
        try{const updated=await api('cart/change.js',{id:item.key,quantity});badge(updated);if(ticket===serial && dialog.open){drawCart(updated,ticket,trigger);announce('Bag updated.');}}
        catch(e){if(ticket===serial)announce(e.message);}finally{lock(false);}
      }
      const minus=action('−',()=>change(item.quantity-1),'sabo-shop-step');minus.setAttribute('aria-label',`Decrease ${item.product_title}`);
      const plus=action('+',()=>change(item.quantity+1),'sabo-shop-step');plus.setAttribute('aria-label',`Increase ${item.product_title}`);
      const remove=action('Remove',()=>change(0),'sabo-shop-remove');remove.setAttribute('aria-label',`Remove ${item.product_title}`);
      controls.append(minus,el('span',String(item.quantity)),plus,remove);details.append(controls);line.append(img,details);lines.append(line);
    });
    const footer=el('div',null,'sabo-shop-footer');footer.append(el('strong',`Subtotal ${money(cart.total_price)}`),el('p','Shipping and taxes shown at checkout.'));
    const checkout=el('a','Checkout','sabo-shop-button');checkout.href=root+'checkout';
    footer.append(checkout,action('Keep exploring',()=>dialog.close(),'sabo-shop-secondary'));content.append(lines,footer);
  }
  document.querySelectorAll('[data-sabo-product]').forEach(a=>{
    a.setAttribute('aria-haspopup','dialog');
    a.addEventListener('click',e=>{if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)return;e.preventDefault();product(a.dataset.saboProduct,a);});
  });
  document.querySelectorAll('.sabo-bag,[data-sabo-sticky-bag]').forEach(a=>{a.setAttribute('aria-haspopup','dialog');a.addEventListener('click',e=>{e.preventDefault();bag(a);});});
  function refreshBag() { if (!busy) api('cart.js').then(badge).catch(()=>{}); }
  window.addEventListener('pageshow', e => { if (e.persisted) refreshBag(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshBag(); });
  refreshBag();
})();
